import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const agentAuthSessionResponseSchema = jsonObject
export const agentAuthLogoutResponseSchema = jsonObject
export type AgentAuthSessionResponse = z.infer<typeof agentAuthSessionResponseSchema>
export type AgentAuthLogoutResponse = z.infer<typeof agentAuthLogoutResponseSchema>
